import { render } from "./changelog.vue?vue&type=template&id=17c7045a&scoped=true"
import script from "./changelog.vue?vue&type=script&lang=js"
export * from "./changelog.vue?vue&type=script&lang=js"

import "./changelog.vue?vue&type=style&index=0&id=17c7045a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c7045a"]])

export default __exports__